module.exports = __webpack_public_path__ + "static/media/project-register-step2.8f835e84.svg";